module.exports = "<div gw-loader=\"documentsRequest || true\">\r\n    <div gw-documents-list\r\n         documents=\"documents\"\r\n         document-metadata-template=\"documentMetaDataTemplate\"\r\n         associated-entity-name=\"{{associatedEntityName}}\"></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/views/quote/quote-documents.html
// module id = 821
// module chunks = 0